import React from "react";

// Simple, clean "i" logo mark for Indosbook.
// Default: orange rounded-square tile with a white lowercase "i".
// inverted: white tile with an orange "i" — for use on orange backgrounds.
export const IndosbookMark = ({ size = 40, className = "", rounded = true, inverted = false }) => {
  const tile = inverted ? "#ffffff" : "#FF4500";
  const glyph = inverted ? "#FF4500" : "#ffffff";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Indosbook logo"
    >
      <rect
        x="2"
        y="2"
        width="60"
        height="60"
        rx={rounded ? 16 : 4}
        fill={tile}
      />
      {/* dot of the i */}
      <circle cx="32" cy="18" r="5.5" fill={glyph} />
      {/* stem of the i */}
      <rect x="26.5" y="28" width="11" height="24" rx="5.5" fill={glyph} />
    </svg>
  );
};

// Kept for backward compatibility — renders the simple "i" mark.
export const IndosbookMascot = (props) => <IndosbookMark {...props} />;

// Full logo: "i" mark + "indosbook" wordmark
export const IndosbookLogo = ({ size = 34, showText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <IndosbookMark size={size} />
      {showText && (
        <span
          className="font-extrabold tracking-tight text-[#0B2D8C] lowercase"
          style={{
            fontFamily: '"Poppins", Helvetica, Arial, sans-serif',
            fontSize: size * 0.62,
          }}
        >
          indosbook
        </span>
      )}
    </div>
  );
};

export default IndosbookLogo;
